import { render, staticRenderFns } from "./step_aval_2avivienda.vue?vue&type=template&id=1f54902c"
import script from "./step_aval_2avivienda.vue?vue&type=script&lang=js"
export * from "./step_aval_2avivienda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports